import React, { useContext, useState } from 'react';

import { useAllClasses } from '../../NecttosComp/APICaller/queryHooks';
import { FirebaseContext } from '../../context/FirebaseContext';
import { useMutation } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import CustomDropDownKey from '../../myComp/CustomDropDownKey';
import moment from 'moment';
import { Body, Main, Header } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const exportPdfExam = async (olddata) => {
	const instance = await getAxiosTokenInstance();
	let data = {
		collegeId: olddata.collegeId,
		classId: olddata.classId,
		semester: olddata.semester,
		sortBy: olddata.sortBy,
	};
	let url = [`/college/action/semesterAttendanceExcel`];
	try {
		const resp = await instance.post(...url, data, {
			responseType: 'blob',
		});

		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

export const ClassWiseAttendance = ({ onClose }) => {
	const exportPdfMutationExam = useMutation(exportPdfExam);
	const [loading, setLoading] = useState(false);
	const { collegeId } = useContext(FirebaseContext);
	const allClasses = useAllClasses({ needAll: true, classOnly: true });
	const allSemester = [
		{ _id: '1', name: 'Semester 1' },
		{ _id: '2', name: 'Semester 2' },
		{ _id: '3', name: 'Semester 3' },
		{ _id: '4', name: 'Semester 4' },
		{ _id: '5', name: 'Semester 5' },
		{ _id: '6', name: 'Semester 6' },
		{ _id: '7', name: 'Semester 7' },
		{ _id: '8', name: 'Semester 8' },
		{ _id: '9', name: 'Semester 9' },
		{ _id: '10', name: 'Semester 10' },
	];
	const sortBy = [
		{ _id: 'name', name: 'Name of the student' },
		{ _id: 'rollNo', name: 'Attendance / Roll Number' },
		{ _id: 'admisionNo', name: 'College Admision Number' },
		{ _id: 'hallTicketNo', name: 'Halticket / Registeration Number' },
		{ _id: 'capId', name: 'CAP/Application Number' },
	];
	const onInternalMark = async () => {
		setLoading(true);
		try {
			const link = document.createElement('a');
			link.target = '_blank';
			let postData = {
				collegeId,
				semester: state.semester,
				classId: state.classId,
				sortBy: state.sortBy,
			};

			link.download = ('APC ' + allClasses?.data?.find((x) => x?._id === state?.classId)?.batchName + ' ' + allClasses?.data?.find((x) => x?._id === state?.classId)?.shortName + ' (Sem ' + state.semester + ') ' + moment(new Date()).format('DD-MM-YYYY')).replace('.', ' ');
			const pdfData = await exportPdfMutationExam.mutateAsync(postData);
			link.href = URL.createObjectURL(new Blob([pdfData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
			link.click();
			setLoading(false);
			onClose();
		} catch (e) {
			setLoading(false);
		}
	};

	const [state, setState] = useState({});
	return (
		<>
			<Main title='Class Wise Attendance' width='500px' height='500px'>
				<Header>
					<div className='flex justify-end w-full mb-3'>
						<Instruction keyId={'classWiseAttendance '}/>
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					</div>
				</Header>
				<Body>
					<div className=''>
						<Input2 type='drop' fieldName='Select Class' returnKey='classId' optionKey='_id' optionDisplay='className' options={allClasses?.data || []} state={state} setState={setState} className='w-[470px]' didntShowKey />
						<Input2 type='drop' fieldName='Select Semester' returnKey='semester' optionKey='_id' optionDisplay='name' options={allSemester} state={state} setState={setState} className='w-[470px]' didntShowKey />
						<Input2 type='drop' fieldName='Sort By' returnKey='sortBy' optionKey='_id' optionDisplay='name' options={sortBy} state={state} setState={setState} didntShowKey className='w-[470px]' />
					</div>
					<div className='flex justify-start'>
						<Button type='save' onClick={onInternalMark}>
							{' '}
							Download{' '}
						</Button>
					</div>
				</Body>
			</Main>
		</>
	);
};
